<template>
  <div class="half-layout">
    <div class="alert alert-info row" v-if="currentDevice">
      <div class="col-8 alert-text--wrap">
        <strong>目前位置</strong>
        <p>
          第 {{ currentDevice.net.open_times }} 藥櫃, 第 {{ currentDevice.net.row_id }} 層
          <span v-if="currentDevice.pos_row !== 0">
            , 第 {{ currentDevice.pos_row }} 列, 第 {{ currentDevice.relative_col }} 行
          </span>
          
        </p>
      </div>
      <div class="small-net col-4">
        <div v-for="n in numRow" class="small-row" 
        :style="{ order: n, height: `${100/numRow}%`}">
          <div 
          v-for="box in currentNet.device_set"
          v-if="box.pos_row === n"
          :class="{ 'small-box': true, 
            'current-box': box.pos_row === currentDevice.pos_row 
            && box.relative_col === currentDevice.relative_col }">
            
          </div>
        </div>
        <div v-if="currentDevice.pos_row === 0" class="small-row" style="height: 100%; width: 100%">
          <div class="small-box current-box">
            {{ currentDevice.net.row_id }}
          </div>
        </div>
      </div>
    </div>
    <slot></slot>
    <div class="alert alert-danger">
      <span>
        <strong>偵測開啟位置: </strong>
        <span v-for="device in errorDevice" v-if="errorDevice">
          <span v-if="device.type === 'drawer' && device.drawerId === currentDevice.net.row_id" class="alert-device-text">抽屜 {{device.drawerId}} </span>
          <span v-if="device.type === 'drawer' && device.drawerId !== currentDevice.net.row_id" class="error-device-text">抽屜 {{device.drawerId}} </span>
          <span v-if="device.type === 'box' && device.row === currentDevice.pos_row && device.col === currentDevice.relative_col" class="alert-device-text">藥盒 {{ device.row }} - {{ device.col }}  </span>
          <span v-if="device.type === 'box' && (device.row !== currentDevice.pos_row || device.col !== currentDevice.relative_col)" class="error-device-text">藥盒 {{ device.row }} - {{ device.col }}  </span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SystemPanel',
  props: ['unit'],
  computed: {
    systems() {
      return this.$store.getters.systems;
    },
    selectedDevices() {
      if (this.unit === 'drug') {
        return this.$store.state.drug.selectedDrugInDevice;
      }
      return this.$store.state.device.selectedDevices;
    },
    errorDevice() {
      return this.$store.state.device.errorDevices;
    },
    currentDevice() {
      return this.$store.getters.currentDevice;
    },
    currentNet() {
      return this.systems[this.currentDevice.net.system_serial].net_set[(this.currentDevice.net.row_id - 1)];
    },
    numRow() {
      let row = 0;
      this.currentNet.device_set.forEach((device) => {
        if (device.pos_row > row) row = device.pos_row;
      });
      return row;
    },
  },
  mounted() {
  },
};
</script>

<style lang="sass">
.half-layout
  padding: 5px 0
  .row.alert
    margin: 0

.small-net
  display: flex
  flex-direction: column-reverse;
  border-collapse: collapse
  height: 100px
  width: 175px
  padding: 0
  *
    border: 1px solid 

.small-row
  display: table
  width: 100%

.small-box
  display: table-cell
  text-align: center
  font-size: 10px

.alert-text--wrap
  display: flex;
  flex-flow: column;
  justify-content: center;
  padding: 0

.current-box
  animation-duration: 1s;
  animation-name: backgroundChanged;
  animation-iteration-count: infinite;
  animation-direction: alternate;

@keyframes backgroundChanged
  0%
    background-color: transparent
  100%
    background-color: darken(#d9edf7, 20%);

.alert-device-text
  text-decoration: underline;
  padding: 0 5px;

.error-device-text
  color: yellow
</style>





// WEBPACK FOOTER //
// SystemPanel.vue?2383d6b3